/* nb-polish.js — Scroll-reveal IntersectionObserver
   + Global cart-link → cart-drawer interceptor (drawer-only site) */
(function() {
  var revealSelectors = [
    '.nb-hero', '.nb-problem', '.nb-product-intro', '.nb-hiw-header',
    '.nb-hiw-step', '.nb-ts', '.nb-ft-container', '.nb-rp-layout',
    '.nuvie-bc__header', '.nuvie-bc__row', '.nuvie-cmp__split',
    '.nb-reviews-container', '.nb-faq-container', '.nb-closing-cta'
  ];

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.nb-reveal').forEach(function(el) { el.classList.add('nb-visible'); });
      return;
    }
    var dyn = document.querySelectorAll(revealSelectors.join(','));
    dyn.forEach(function(el) { el.classList.add('nb-reveal'); });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nb-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.nb-reveal').forEach(function(el) { io.observe(el); });
  }

  /* ── Cart-drawer-only enforcement ─────────────────────────────
     Click on any /cart link anywhere on the site → open drawer,
     never navigate. Direct URL entry to /cart still works. */

  function manuallyOpenDrawer(drawer) {
    drawer.classList.add('m-cart-drawer--active');
    document.documentElement.classList.add('prevent-scroll');
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        drawer.style.setProperty('--m-bg-opacity', '0.5');
        drawer.style.setProperty('--translate-x', '0');
      });
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('m-cart-drawer, #MinimogCartDrawer, .m-cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        try { drawer.open(); return true; } catch (e) { /* fall through */ }
      }
      // Web component not upgraded yet — flip the active class manually.
      manuallyOpenDrawer(drawer);
      return true;
    }
    var toggle = document.querySelector('[data-cart-toggle], .m-cart-icon-bubble, .m-cart-icon');
    if (toggle) { toggle.click(); return true; }
    return false;
  }

  function isCartHref(el) {
    if (!el || !el.getAttribute) return false;
    var href = el.getAttribute('href');
    if (!href) return false;
    var clean = href.split('#')[0].split('?')[0].replace(/\/+$/, '');
    return /^\/?(?:[a-z]{2}(?:-[a-z]{2,3})?\/)?cart$/i.test(clean);
  }

  function initCartIntercept() {
    document.addEventListener('click', function(e) {
      // Honor cmd/ctrl/shift/alt/middle-click → open in new tab as expected
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var link = e.target.closest('a[href]');
      if (!link || !isCartHref(link)) return;

      // Explicit opt-outs
      if (link.hasAttribute('data-no-drawer') || link.target === '_blank') return;

      // ALWAYS block in-site navigation to /cart, regardless of drawer state.
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Best-effort open. If element isn't ready yet, retry on next frame.
      if (!openCartDrawer()) {
        requestAnimationFrame(function() { openCartDrawer(); });
      }
    }, true);
  }

  function init() {
    initReveal();
    initCartIntercept();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
